module.exports = __webpack_public_path__ + "static/CATM_Square-6d7ed86f788dbe77e87c3dc16bf76b83.jpg";